/* eslint-disable import/prefer-default-export */
import qs from 'qs';

export const parseLocationUrl = function parseLocationUrl(state) {
    const { location = {} } = state.router;

    // TODO: Determine root cause of injected ??
    const search = qs.parse(location.search || '', { ignoreQueryPrefix: true });
    if (search.from && search.from.includes('??')) {
        search.from = search.from.split('??')[0];
    }

    return {
        pathname: location.pathname || '/',
        hash: location.hash || '',
        search
    };
};

export const getCurrentPathname = function getCurrentPathname(state) {
    return state.router.location.pathname;
};

export const getParsedLocation = function getParsedLocation(state) {
    return state.router.parsedUrl;
};

export const getWhitelabelKey = function getWhitelabelKey(state) {
    return state.router.whitelabelKey;
};



// WEBPACK FOOTER //
// ./src/services/router/selectors.js